import { Stack } from "@mui/material";
import { BetaInfoContent } from "Components/Beta/BetaInfoContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

export const BetaInfoPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Beta.MenuItem)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("settings"),
      }}
    >
      <StyledPageWrapper>
        <Stack className="left-content">
          <PrimaryPaper>
            <BetaInfoContent isTitleHidden />
          </PrimaryPaper>
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default BetaInfoPage;
